import React, { useState, useEffect } from 'react';
import { TESTIMONIALS } from '../../data/appData';

function StarRating({ count }) {
  return (
    <div style={{ display: 'flex', gap: '3px' }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} style={{ color: i < count ? '#ffc107' : 'var(--border-color)', fontSize: '14px' }}>★</span>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => setActive(a => (a + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(interval);
  }, [paused]);

  return (
    <section className="section" style={{ background: 'var(--bg-secondary)', overflow: 'hidden' }}>
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Müşteri Yorumları</div>
          <h2 className="section-title">
            <span className="gradient-text">25.000+</span> Mutlu Müşteri
          </h2>
          <p className="section-subtitle">
            Google'da 4.9/5 ortalama puan ile Ankara'nın en güvenilir tesisat firması
          </p>
        </div>

        {/* Large featured review */}
        <div
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          style={{
          background: 'var(--gradient-hero)',
          borderRadius: 'var(--radius-xl)',
          padding: 'clamp(32px, 5vw, 56px)',
          marginBottom: '24px',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Quote mark */}
          <div style={{
            position: 'absolute', top: '20px', right: '32px',
            fontSize: '120px',
            fontFamily: 'Georgia, serif',
            color: 'rgba(255,255,255,0.06)',
            lineHeight: 1,
            userSelect: 'none',
          }}>"</div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: '32px',
            alignItems: 'start',
          }}>
            <div>
              <StarRating count={TESTIMONIALS[active].rating} />
              <p key={active} style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.35rem)',
                color: 'rgba(255,255,255,0.92)',
                lineHeight: 1.65,
                marginTop: '20px',
                marginBottom: '24px',
                fontStyle: 'italic',
                animation: 'fadeIn 0.5s ease both',
              }}>
                "{TESTIMONIALS[active].text}"
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{
                  width: '48px', height: '48px',
                  borderRadius: '50%',
                  background: 'var(--gradient-teal)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  color: 'white',
                  fontSize: '1rem',
                }}>{TESTIMONIALS[active].avatar}</div>
                <div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'white', fontSize: '1rem' }}>
                    {TESTIMONIALS[active].name}
                  </div>
                  <div style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)' }}>
                    {TESTIMONIALS[active].role} · {TESTIMONIALS[active].location}
                  </div>
                </div>
                <div style={{
                  marginLeft: 'auto',
                  padding: '4px 12px',
                  borderRadius: 'var(--radius-full)',
                  background: 'rgba(0,180,204,0.2)',
                  border: '1px solid rgba(0,180,204,0.3)',
                  fontSize: '0.75rem',
                  color: 'var(--teal-bright)',
                  fontWeight: 600,
                }}>
                  {TESTIMONIALS[active].service}
                </div>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div style={{ display: 'flex', gap: '8px', marginTop: '24px' }}>
            {TESTIMONIALS.map((_, i) => (
              <button key={i} onClick={() => setActive(i)} style={{
                width: i === active ? '24px' : '8px',
                height: '8px',
                borderRadius: 'var(--radius-full)',
                background: i === active ? 'var(--teal)' : 'rgba(255,255,255,0.25)',
                border: 'none', cursor: 'pointer',
                transition: 'all 0.3s',
              }}/>
            ))}
          </div>
        </div>

        {/* All cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '16px',
        }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={t.id}
              onClick={() => setActive(i)}
              style={{
                padding: '20px',
                borderRadius: 'var(--radius-md)',
                background: active === i ? 'rgba(0,180,204,0.06)' : 'var(--bg-card)',
                border: `1px solid ${active === i ? 'rgba(0,180,204,0.3)' : 'var(--border-color)'}`,
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                <div style={{
                  width: '36px', height: '36px',
                  borderRadius: '50%',
                  background: 'var(--gradient-ocean)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700, fontSize: '0.8rem', color: 'white',
                }}>{t.avatar}</div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--text-primary)' }}>{t.name}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{t.date}</div>
                </div>
                <StarRating count={t.rating} />
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                "{t.text.slice(0, 100)}..."
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
